var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[(_vm.loaded)?_c('div',[_vm._t("default")],2):_c('div',{staticClass:"text-center mt-3"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }